var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticStyle:{"width":"100%","display":"flex","align-items":"center","flex-direction":"column","justify-content":"center"}},[_c('img',{staticStyle:{"width":"100%"},attrs:{"src":require("../../static/other/yaoxing.png")}}),_c('img',{staticStyle:{"width":"100%"},attrs:{"src":require("../../static/other/yaoxing2.png")}})])])
}]

export { render, staticRenderFns }